import { Component, Inject, Input } from '@angular/core';
import { FeedbackHistory } from '@ridango/components/lib/feedback';

@Component({
    selector: 'rwidget-feedback-history',
    templateUrl: './feedback-history.component.html',
    styleUrls: ['./feedback-history.component.scss']
})
export class FeedbackHistoryComponent {
    @Input() feedbackHistoryList: FeedbackHistory[];

    constructor(@Inject('ENV') public env) {}
}
